// extracted by mini-css-extract-plugin
export default {"tabs":"W49XV+9nc-","indicator":"_6XeaaDNebc","error":"KiuuZCNsOx"};